import React from "react";
import { Row, Col, Collapse } from "reactstrap";
//import "../../node_modules/video-react/dist/video-react.css"; // import css
import Tex from "../components/Tex";
import Choice from "../components/Choice";
import { video_path } from "../constants";
//import {websiteurl,video_path} from '../constants'
import Swipeable from "react-swipeable";
import Video from './Video'
export default class MC extends React.Component {
  render() {
    const {
      qnum,
      qID,
      qtext,
      choices,
      youtubeID,
      select,
      correct
    } = this.props;
    const selectChoice = this.props.selectChoice.bind(this, qnum); // we can use it within map.
    const ans = this.props.ans || null;
    const path = video_path + youtubeID;
	//console.log("path", path);
    return (
      <div>
        <Swipeable
          onSwipedLeft={this.props.Next}
          onSwipedRight={this.props.Prev}
        >
          <Row>
            <Col>
              <h2 className="text-center"> Question - {qID} </h2>
            </Col>
          </Row>
          <Row>{' '} </Row>
          <Row>
            <Col>
              <p>
                <Tex bind={qtext} />
              </p>
            </Col>
          </Row>
          {choices.map(choice => (
            <Choice
              key={choice.ID}
              cID={choice.ID}
              correct={correct}
              select={select}
              ctext={choice.ctext}
              ans={ans}
              selectChoice={() => selectChoice(choice.ID)}
            />
          ))}
        </Swipeable>
        <Row>{' '}</Row>
        <Collapse isOpen={correct != null}>
		  <Video  url={path} onStart={this.props.onStart}/>
        </Collapse>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MC.js